<template>
  <div
    :class="`${fixedHeader ? 'sticky left-0 top-0 z-50' : ''} flex w-full items-center justify-between rounded-t-xl bg-white p-4`"
  >
    <slot name="left-item">
      <div class="min-w-[24px]">
        <VBtn v-if="activatePrev" :disabled="!isActivated" @click="prev">
          <BaseIcon size="24" icon-color="cBlack" viewbox="0 0 28 28"
            ><IconLeft
          /></BaseIcon>
        </VBtn>
      </div>
    </slot>

    <!-- HACK: ローディングのバグを解決するためにタイトルの色を交互に変化させる -->
    <h1
      class="pointer-events-none mx-3 break-words text-center text-base font-bold"
      :class="resolverFlag ? 'text-cBlack' : 'text-[#212121]'"
    >
      {{ title }}
    </h1>

    <slot name="right-item">
      <div class="min-w-[24px]">
        <VBtn v-if="activateClose" :disabled="!isActivated" @click="close">
          <BaseIcon size="24" icon-color="cBlack" viewbox="0 0 28 28"
            ><IconClose
          /></BaseIcon>
        </VBtn>
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
  import { useScreenFreezeResolver } from '@/composables/useScreenFreezeResolver';

  export interface Props {
    title: string;
    activatePrev?: boolean;
    activateClose?: boolean;
    fixedHeader?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    activatePrev: false,
    activateClose: false,
  });

  const emit = defineEmits<{
    (e: 'prev'): void;
    (e: 'close'): void;
  }>();

  const { resolverFlag } = useScreenFreezeResolver();

  // ボタン連打防止のためのフラグ
  const isActivated = ref(true);

  const prev = () => {
    if (!isActivated.value) return;
    isActivated.value = false;
    emit('prev');
  };

  const close = () => {
    if (!isActivated.value) return;
    isActivated.value = false;
    emit('close');
  };
</script>
